
import { ReservationTypes } from 'consts';
import { DefaultState } from 'store/types';

export const SAVE_GUEST_TO_DRAFT_REQUEST = 'SAVE_GUEST_TO_DRAFT_REQUEST';
export const SAVE_GUEST_TO_DRAFT_SUCCESS = 'SAVE_GUEST_TO_DRAFT_SUCCESS';
export const SAVE_GUEST_TO_DRAFT_FAILURE = 'SAVE_GUEST_TO_DRAFT_FAILURE';


export interface SaveGuestToDraftParams {
  roomId: string;
  lodgingRequestId: string;
  doNotSendNotificationToAssociate: boolean;
  doNotSendNotificationToCLC: boolean;
  guestReservationType?: ReservationTypes
  reservationProviderId: string;
};

export interface SaveGuestToDraftData {

};

export type SaveGuestToDraftState = DefaultState & {
  contents?: SaveGuestToDraftData;
};

interface SaveGuestToDraftDataRequest {
  type: typeof SAVE_GUEST_TO_DRAFT_REQUEST;
};

interface SaveGuestToDraftDataSuccess {
  type: typeof SAVE_GUEST_TO_DRAFT_SUCCESS,
  contents: SaveGuestToDraftData;
}

interface SaveGuestToDraftDataFailure {
  type: typeof SAVE_GUEST_TO_DRAFT_FAILURE;
}

export type SaveGuestToDraftActionTypes = SaveGuestToDraftDataRequest | SaveGuestToDraftDataSuccess | SaveGuestToDraftDataFailure;